import { createContext, ReactNode, useContext, useState } from 'react';
import Modal, { ModalProps } from '../components/atoms/Modal';

type ModalContext = { toggleModal: (modalState?: ModalProps) => void };
const ModalContext = createContext<ModalContext>({} as any);

export const ModalProvider = ({ children }: { children: ReactNode }) => {
  const [modal, setModal] = useState<ModalProps>();

  return (
    <ModalContext.Provider value={{ toggleModal: (_modal?: ModalProps) => setModal(_modal) }}>
      {modal && <Modal {...modal} />}
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => useContext(ModalContext);
